<template>
  <!-- 头部导航容器 -->
  <div class="header-container">
    <div class="header-wrap">
      <!-- 左侧Logo和网站名称区域 -->
      <div class="header-left flex-shrink-0" @click="handleGoHome">
        <!-- <img
          class="header-img"
          :src="pageInfo.centerLogoUrl"
          alt=""
          v-if="pageInfo.centerLogoUrlState == 1"
        /> -->
        <span v-if="pageInfo.centerWebsiteNameState == 1">{{
          pageInfo.centerWebsiteName
        }}</span>
      </div>
      
      <!-- 中间导航菜单区域 -->
      <div class="header-menu flex-1 overflow-x-auto">
        <el-menu
          v-if="!isLoginPage"
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          background-color="#1bb2ad"
          text-color="#fff"
          active-text-color="#1bb2ad"
          @select="handleSelect"
        >
          <template>
            <!-- 诊所管理菜单项  -->
            <el-menu-item
              index="0"
              v-if="
                (userInfo.customerTypes.indexOf('1') != -1 ||
                  userInfo.customerTypes.indexOf('2') != -1) &&
                (!isNonMedical || isYk || isLongtang) &&
                customerManageTypes?.indexOf('15') > -1 &&
                !(getCacheUserInfo().doctorAccountType && !getCacheUserInfo().customerAccountType)
              "
              >{{ customerTyeCodeName }}管理</el-menu-item
            >
            <!-- <el-menu-item
              index="0"
              v-else-if="
                customerManageTypes?.indexOf('15') > -1
              "
              >{{ customerTyeCodeName }}管理</el-menu-item
            > -->

            <!-- 首页菜单项 -->
            <el-menu-item index="1" v-if="userInfo.customerTypes.indexOf('3') != -1 || isLongtang"
              >首页</el-menu-item
            >
            
            <!-- 检索菜单项 -->
            <el-menu-item index="16" v-if="customerManageTypes?.indexOf('13') > -1"
              >检索</el-menu-item
            >
            <!-- 中医口腔菜单项 -->
            <el-menu-item
                index="22"
                v-if="
                ((!isNonMedical) || isLongtang) &&
                (userInfo.customerTypes.indexOf('3') != -1 || isLongtang) &&
                customerManageTypes?.indexOf('23') > -1
              "
            >中医口腔</el-menu-item>
            
            <!-- 中医临床菜单项 -->
            <el-menu-item
              index="2"
              v-if="
                (userInfo.customerTypes.indexOf('3') != -1 || isLongtang) &&
                customerManageTypes?.indexOf('1') > -1
              "
            >
              {{ isNonMedical && !isYk && !isNanchuan && !isTunan && !isLongtang ? "中医类信息录入" : "中医临床" }}
            </el-menu-item>
            
            <!-- 中西医结合菜单项 -->
            <el-menu-item
              index="9"
              v-if="
                (userInfo.customerTypes.indexOf('3') != -1 || isLongtang) &&
                customerManageTypes?.indexOf('2') > -1
              "
            >
              {{
                isNonMedical && !isYk && !isNanchuan && !isTunan && !isLongtang ? "中西医结合类信息录入" : "中西医结合"
              }}
            </el-menu-item>
            
            <!-- 中医AI菜单项 -->
            <el-menu-item
              index="3"
              v-if="
                (userInfo.customerTypes.indexOf('3') != -1 || isLongtang) &&
                customerManageTypes?.indexOf('3') > -1
              "
              >中医AI</el-menu-item
            >
            
            <!-- 慢病管理菜单项 -->
            <el-menu-item
              index="10"
              v-if="
                (userInfo.customerTypes.indexOf('3') != -1 || isLongtang) &&
                customerManageTypes?.indexOf('4') > -1
              "
            >
              {{ isNonMedical && !isYk && !isNanchuan && !isTunan && !isLongtang ? "慢性疾病录入" : "慢病管理" }}
            </el-menu-item>
            
            <!-- 体质辨识菜单项 -->
            <el-menu-item
              index="4"
              v-if="
                (userInfo.customerTypes.indexOf('3') != -1 || isLongtang) &&
                customerManageTypes?.indexOf('5') > -1
              "
              >体质辨识</el-menu-item
            >

            <!-- 体质辨识（儿童）菜单项 -->
            <el-menu-item
              index="17"
              v-if="
                userInfo.customerTypes.indexOf('3') != -1 &&
                (
                  customerManageTypes?.indexOf('16') > -1 ||
                  customerManageTypes?.indexOf('17') > -1 ||
                  customerManageTypes?.indexOf('18') > -1
                )
              "
              >体质辨识（儿童）</el-menu-item
            >

            <!-- 体质辨识（老年人）菜单项 -->
            <el-menu-item
              index="18"
              v-if="
                userInfo.customerTypes.indexOf('3') != -1 &&
                customerManageTypes?.indexOf('19') > -1
              "
              >体质辨识（老年人）</el-menu-item
            >

            <!-- 体质辨识（成年女性）菜单项 -->
            <el-menu-item
              index="19"
              v-if="
                userInfo.customerTypes.indexOf('3') != -1 &&
                customerManageTypes?.indexOf('20') > -1
              "
              >体质辨识（成年女性）</el-menu-item
            >

            <!-- 中医康养菜单项 -->
            <el-menu-item
              index="11"
              v-if="
                ((!isNonMedical) || isLongtang) &&
                (userInfo.customerTypes.indexOf('3') != -1 || isLongtang) &&
                customerManageTypes?.indexOf('6') > -1
              "
              >中医康养</el-menu-item
            >
            
            <!-- 中医针灸菜单项 -->
            <el-menu-item
              index="12"
              v-if="
                ((!isNonMedical) || isLongtang) &&
                (userInfo.customerTypes.indexOf('3') != -1 || isLongtang) &&
                customerManageTypes?.indexOf('9') > -1
              "
              >中医针灸</el-menu-item
            >
            
            <!-- 中医贴敷菜单项 -->
            <el-menu-item
              index="14"
              v-if="
                ((!isNonMedical) || isLongtang) &&
                (userInfo.customerTypes.indexOf('3') != -1 || isLongtang) &&
                customerManageTypes?.indexOf('11') > -1
              "
              >中医贴敷</el-menu-item
            >
            
            <!-- 流感2025菜单项 -->
            <el-menu-item
              index="15"
              v-if="
                ((!isNonMedical) || isLongtang) &&
                (userInfo.customerTypes.indexOf('3') != -1 || isLongtang) &&
                customerManageTypes?.indexOf('12') > -1
              "
              >流感2025</el-menu-item
            >
            
            <!-- 知识库菜单项 -->
            <el-menu-item
              index="13"
              v-if="
                ((!isNonMedical) || isLongtang) &&
                (userInfo.customerTypes.indexOf('3') != -1 || isLongtang) &&
                customerManageTypes?.indexOf('10') > -1
              "
              >知识库</el-menu-item
            >
            
            <!-- 中医数字人小课堂菜单项 -->
            <el-menu-item
                index="20"
                v-if="
                ((!isNonMedical) || isLongtang) &&
                (userInfo.customerTypes.indexOf('3') != -1 || isLongtang) &&
                customerManageTypes?.indexOf('21') > -1
              "
            >中医数字人小课堂</el-menu-item>

            <!-- 扶阳医学菜单项 -->
            <el-menu-item
                index="21"
                v-if="
                ((!isNonMedical) || isLongtang) &&
                (userInfo.customerTypes.indexOf('3') != -1 || isLongtang) &&
                customerManageTypes?.indexOf('22') > -1
              "
            >扶阳医学</el-menu-item>

            <!-- 视频咨询菜单项 -->
            <el-menu-item
              index="7"
              v-if="
                (userInfo.customerTypes.indexOf('3') != -1 || isLongtang) &&
                customerManageTypes?.indexOf('14') > -1
              "
            >
              视频咨询
            </el-menu-item>
            
            <!-- 专家咨询菜单项 -->
            <el-menu-item index="8" v-if="userInfo.customerTypes.indexOf('8') != -1"
              >专家咨询</el-menu-item
            >

          </template>
        </el-menu>
      </div>
      
      <!-- 右侧用户信息区域 -->
      <div class="header-right flex-shrink-0">
        <div
          v-if="!isLoginPage"
          class="header-user"
          @click="toggleUserMenu"
          v-click-outside="outsideClick"
        >
          <!-- 用户头像 -->
          <img class="avatar-img" src="@/assets/images/user_nav_header_icon.png" alt="" />
          
          <!-- 用户名或登录按钮 -->
          <div v-if="userInfo.userName" class="name">
            {{ userInfo.userName }}
          </div>
          <div v-else @click="goLogin" class="name">登录</div>
          
          <!-- 下拉箭头 -->
          <span class="arrow_down"></span>
          
          <!-- 用户下拉菜单 -->
          <div
            v-if="showUserMenu"
            :class="['user-menu', userInfo.customerType != 8 && 'posi']"
          >
            <!-- 修改密码菜单项 -->
            <div
              v-if="userInfo.customerType != 8"
              class="user-menu-item"
              @click="handleCommand('fixpassword')"
            >
              <img class="icon" src="@/assets/images/lock_icon.png" alt="" />
              修改密码
            </div>
            
            <!-- 退出登录菜单项 -->
            <div class="user-menu-item" @click="handleCommand('logout')">
              <img class="icon" src="@/assets/images/lagout_icon.png" alt="" />
              退出登录
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 儿童体质辨识弹窗组件 -->
    <ChildrenPhysiqueDialog 
      :visible="showChildrenDialog"
      @close="handleCloseChildrenDialog"
      @confirm="handleConfirmChildren"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { logoutPost, logoutPost2 } from "@/service/user";
import ChildrenPhysiqueDialog from "@/components/ChildrenPhysiqueDialog.vue";

export default {
  name: "Header",
  components: {
    ChildrenPhysiqueDialog, // 儿童体质辨识弹窗组件
  },
  data() {
    return {
      // 需要隐藏头部导航的页面名称数组
      hidePathNames: ["login", "forgetPassword", "clinic", "demonstrate"],
      isShow: false,
      isLoginPage: false, // 是否为登录页面
      activeIndex: "1", // 当前激活的菜单索引
      showUserMenu: false, // 是否显示用户下拉菜单
      curPageName: "", // 当前页面名称
      
      // 页面路径配置数组，用于菜单跳转
      pagePath: [
        { path: "/clinicManager" }, // 诊所管理
        { path: "/home" }, // 首页
        { path: "/clinical" }, // 中医临床
        { path: "/channels" }, // 中医AI
        { path: "/physique", query: { from: "physique" } }, // 体质辨识
        { path: "/covid19" }, // 新冠专题
        { path: "/demonstrate" }, // 操作演示
        { path: "/videoConsultation" }, // 视频咨询
        { path: "/doctorVideo" }, // 专家咨询
        { path: "/clinical2" }, // 中西医结合
        { path: "/slow" }, // 慢病管理
        { path: "/healthy" }, // 中医康养
        { path: "/acupuncture" }, // 中医针灸
        { path: "/knowledge" }, // 知识库
        { path: "/application" }, // 中医贴敷
        { path: "/liugan" }, // 流感
        { path: "/easy" }, // 检索
        { path: ""}, // 儿童体质辨识占位
        { path: "/physiqueSpecialMan", query: { type: "oldMan" }}, // 体质辨识（老年人）
        { path: "/physiqueSpecialWoMan", query: { type: "woMan" }}, // 体质辨识（成年女性）
        { path: "/popularizeVideo" }, // 中医数字人小课堂
        { path: "/fyyx" }, // 扶阳医学
        { path: "/clinicalKouqiang" }, // 中医口腔
      ],

      // 儿童体质辨识路由配置，根据年龄段分类
      physiqueChildren: {
        'infant': { // 婴儿期
          path: '/physiqueChildren',
          query: { from: 'physiqueChildren', type: 'infant' }
        },
        'children': { // 儿童期
          path: '/physiqueChildren',
          query: { from: 'physiqueChildren',  type: 'children' }
        },
        'adolescent': { // 青少年期
          path: '/physiqueChildren',
          query: { from: 'physiqueChildren',  type: 'adolescent' }
        }
      }
    };
  },
  
  // 监听路由变化，更新当前激活的菜单索引
  watch: {
    $route(to, from) {
      const name = to.name;
      this.filterCurIndex(name);
    },
    // 监听用户信息变化，重新检查菜单权限
    userInfo: {
      handler(newVal, oldVal) {
        if (newVal && Object.keys(newVal).length > 0 && this.$route.name) {
          // 用户信息更新后，延迟重新检查当前页面的菜单权限
          // 避免在权限更新过程中立即触发检查
          setTimeout(() => {
            this.filterCurIndex(this.$route.name);
          }, 100);
        }
      },
      deep: true,
      immediate: false
    },
    // 监听客户管理类型变化
    customerManageTypes: {
      handler(newVal, oldVal) {
        if (newVal && newVal.length > 0 && this.$route.name) {
          // 客户管理类型更新后，延迟重新检查当前页面的菜单权限
          // 避免在权限更新过程中立即触发检查
          setTimeout(() => {
            this.filterCurIndex(this.$route.name);
          }, 100);
        }
      },
      immediate: false
    }
  },
  
  computed: {
    // 从Vuex store中映射状态
    ...mapState({
      customerTyeCodeName: (state) => state.user.customerTyeCodeName, // 客户类型代码名称
      userInfo: (state) => state.user.userInfo, // 用户信息
      isLogin: (state) => state.user.isLogin, // 是否已登录
      isNonMedical: (state) => state.user.isNonMedical, // 是否非医疗
      showChildrenDialog: (state) => state.showChildrenDialog, // 儿童体质辨识弹窗显示状态
    }),
    
    // 从Vuex store中映射getters
    ...mapGetters(["pageInfo"]), // 页面信息
    
    // 客户管理类型数组，将字符串转换为数组
    customerManageTypes() {
      if (!this.userInfo?.customerManageTypes) return [];
      if (typeof this.userInfo?.customerManageTypes == "object")
        return this.userInfo?.customerManageTypes;
      return this.userInfo?.customerManageTypes?.split(",");
    },
    
    // 是否为炎黄益康
    isYk() {
      return (
        this.userInfo.customerAccountType == 5 || this.userInfo.doctorAccountType == 5
      );
    },
    
    // 是否为图南
    isTunan() {
      return (
        this.userInfo.customerAccountType == 6 || this.userInfo.doctorAccountType == 6
      );
    },
    
    // 是否为南川
    isNanchuan() {
      return (
        this.userInfo.customerAccountType == 7 || this.userInfo.doctorAccountType == 7
      );
    },

    // 是否为龙塘
    isLongtang() {
      return (
        this.userInfo.customerAccountType == 12 || this.userInfo.doctorAccountType == 12
      );
    },
  },
  
  // 组件创建时的生命周期钩子
  created() {
    const { name } = this.$route;
    this.isLoginPage = this.hidePathNames.indexOf(name) > -1; // 判断是否为登录页面
  },
  
  // 组件挂载后的生命周期钩子
  mounted() {
    const { name } = this.$route;
    
    // 确保组件完全挂载后再检查菜单权限
    this.$nextTick(() => {
      this.filterCurIndex(name);
    });
  },
  
  methods: {
    /**
     * 从缓存中获取用户信息
     * @returns {Object} 用户信息对象
     */
    getCacheUserInfo() {
      try {
        // 优先从sessionStorage获取，如果没有再从localStorage获取
        const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
        if (Object.keys(userInfo).length > 0) {
          return userInfo;
        }
        
        // 如果sessionStorage中没有，尝试从localStorage获取
        const localUserInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        return localUserInfo;
      } catch (error) {
        console.error('获取缓存用户信息失败:', error);
        return {};
      }
    },
    
    /**
     * 处理菜单选择事件
     * @param {string} tab - 选中的菜单索引
     */
    handleSelect(tab) {
      // 特殊处理：点击体质辨识（儿童）时显示弹窗
      if(tab == 17) {
        this.$store.commit('setShowChildrenDialog', true);
        return;
      }
      
      // 根据选中的索引获取对应的路由路径
      const pathArr = this.pagePath[tab].path.split("/");
      const name = pathArr[pathArr.length - 1];
      
      // 埋点统计：记录菜单点击事件
      window.aplus_queue.push({
        action: "aplus.record",
        arguments: [
          "_sjy.tab.clk",
          "CLK",
          {
            param1: name,
          },
        ],
      });
      
      // 设置当前菜单名称并跳转路由
      this.$store.commit("setCurrentMenuName", name);
      
      // 特殊处理扶阳医学跳转
      if(tab == 21 || tab === '21') {
        this.$router.push('/fyyx');
      } else {
        this.$router.push(this.pagePath[tab]);
      }
    },
    
    /**
     * 处理用户菜单命令
     * @param {string} command - 命令类型：'logout' | 'fixpassword'
     */
    async handleCommand(command) {
      if (command == "logout") {
        // 退出登录逻辑
        window.aplus_queue.push({
          action: "aplus.record",
          arguments: [
            "_sjy.header.logout.clk",
            "CLK",
            {
              param1: this.$route.name,
            },
          ],
        });
        
        try {
          // 根据用户类型选择不同的退出登录接口
          const request = this.userInfo.customerType == 8 ? logoutPost2 : logoutPost;
          const { code, msg } = await request();
          
          if (code != 200) return this.$message.error(msg);
          
          // 清空用户信息和状态
          this.$store.commit("user/setUserInfo", {});
          this.$store.commit("user/setCustomerTyeCodeName", 0);
          this.$store.commit("user/setIsLogin", false);
          this.$store.commit("user/setIsNonMedical", false);
          this.$store.commit("user/setAuthoritys", {});
          sessionStorage.removeItem("userInfo");
          
          // 跳转到登录页面
          let url = localStorage.getItem("url");
          if (this.pageInfo.localFlag == 1) {
            window.location.href = `${window.location.origin}`;
          } else {
            window.location.href = url;
          }
          
        } catch (error) {
          console.log(error);
        }
      } else {
        // 修改密码逻辑
        window.aplus_queue.push({
          action: "aplus.record",
          arguments: [
            "_sjy.header.editPassWord.clk",
            "CLK",
            {
              param1: this.$route.name,
            },
          ],
        });
        
        // 跳转到修改密码页面
        this.$router.push({
          name: "fixPassword",
        });
      }
    },
    
    /**
     * 切换用户下拉菜单显示状态
     */
    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu;
    },
    
    /**
     * 跳转到登录页面
     */
    goLogin() {
      this.$router.push({
        name: "login",
      });
    },
    
    /**
     * 检查指定菜单索引是否在页面上显示
     * @param {string} index - 菜单索引
     * @returns {boolean} 是否显示
     */
    isMenuVisible(index) {
      switch (index) {
        case "0": // 诊所管理
          return (
            (this.userInfo.customerTypes.indexOf('1') != -1 ||
              this.userInfo.customerTypes.indexOf('2') != -1) &&
            (!this.isNonMedical || this.isYk) &&
            this.customerManageTypes?.indexOf('15') > -1 &&
            !(this.getCacheUserInfo().doctorAccountType && !this.getCacheUserInfo().customerAccountType)
          );
        case "1": // 首页
          return this.userInfo.customerTypes.indexOf('3') != -1;
        case "2": // 中医临床
          return (
            this.userInfo.customerTypes.indexOf('3') != -1 &&
            this.customerManageTypes?.indexOf('1') > -1
          );
        case "3": // 中医AI
          return (
            this.userInfo.customerTypes.indexOf('3') != -1 &&
            this.customerManageTypes?.indexOf('3') > -1
          );
        case "4": // 体质辨识
          return (
            this.userInfo.customerTypes.indexOf('3') != -1 &&
            this.customerManageTypes?.indexOf('5') > -1
          );
        case "7": // 视频咨询
          return (
            this.userInfo.customerTypes.indexOf('3') != -1 &&
            this.customerManageTypes?.indexOf('14') > -1
          );
        case "8": // 专家咨询
          return this.userInfo.customerTypes.indexOf('8') != -1;
        case "9": // 中西医结合
          return (
            this.userInfo.customerTypes.indexOf('3') != -1 &&
            this.customerManageTypes?.indexOf('2') > -1
          );
        case "10": // 慢病管理
          return (
            this.userInfo.customerTypes.indexOf('3') != -1 &&
            this.customerManageTypes?.indexOf('4') > -1
          );
        case "11": // 中医康养
          return (
            !this.isNonMedical &&
            this.userInfo.customerTypes.indexOf('3') != -1 &&
            this.customerManageTypes?.indexOf('6') > -1
          );
        case "12": // 中医针灸
          return (
            !this.isNonMedical &&
            this.userInfo.customerTypes.indexOf('3') != -1 &&
            this.customerManageTypes?.indexOf('9') > -1
          );
        case "13": // 知识库
          return (
            !this.isNonMedical &&
            this.userInfo.customerTypes.indexOf('3') != -1 &&
            this.customerManageTypes?.indexOf('10') > -1
          );
        case "14": // 中医贴敷
          return (
            !this.isNonMedical &&
            this.userInfo.customerTypes.indexOf('3') != -1 &&
            this.customerManageTypes?.indexOf('11') > -1
          );
        case "15": // 流感
          return (
            !this.isNonMedical &&
            this.userInfo.customerTypes.indexOf('3') != -1 &&
            this.customerManageTypes?.indexOf('12') > -1
          );
        case "16": // 检索
          return this.customerManageTypes?.indexOf('13') > -1;
        case "17": // 体质辨识（儿童）
          return (
            this.userInfo.customerTypes.indexOf('3') != -1 &&
            (
              this.customerManageTypes?.indexOf('16') > -1 ||
              this.customerManageTypes?.indexOf('17') > -1 ||
              this.customerManageTypes?.indexOf('18') > -1
            )
          );
        case "18": // 体质辨识（老年人）
          return (
            this.userInfo.customerTypes.indexOf('3') != -1 &&
            this.customerManageTypes?.indexOf('19') > -1
          );
        case "19": // 体质辨识（成年女性）
          return (
            this.userInfo.customerTypes.indexOf('3') != -1 &&
            this.customerManageTypes?.indexOf('20') > -1
          );
        case "20": // 中医数字人小课堂
          return (
            !this.isNonMedical &&
            this.userInfo.customerTypes.indexOf('3') != -1 &&
            this.customerManageTypes?.indexOf('21') > -1
          );
        case "21": // 扶阳医学
          return (
            ((!this.isNonMedical) || this.isLongtang) &&
            (this.userInfo.customerTypes.indexOf('3') != -1 || this.isLongtang) &&
            this.customerManageTypes?.indexOf('22') > -1
          );
        case "22": // 中医口腔
          return (
              !this.isNonMedical &&
              this.userInfo.customerTypes.indexOf('3') != -1 &&
              this.customerManageTypes?.indexOf('23') > -1
          );
        default:
          return false;
      }
    },

    /**
     * 根据当前路由名称过滤并设置激活的菜单索引
     * @param {string} name - 路由名称
     */
    filterCurIndex(name) {
      // 如果用户信息还没有加载完成，延迟检查
      if (!this.userInfo || Object.keys(this.userInfo).length === 0) {
        console.log('用户信息未加载完成，延迟检查菜单权限');
        setTimeout(() => {
          this.filterCurIndex(name);
        }, 100);
        return;
      }
      
      let hasMenu = false;
      let menuIndex = null;
      
      // 诊所管理相关页面
      if (
        name == "clinicManager" ||
        name == "clinicEquipment" ||
        name == "clinicEquipmentRecord" ||
        name == "equipmentReport" ||
        name == "clinicDiagnose" ||
        name == "clinicPatient" ||
        name == "statistics" ||
        name == "finance" ||
        name == "clinicOrder" ||
        name == "clinicDoctor" ||
        name == "clinicDoctorCust" ||
        name == "clinicDoctorCustom"
      ) {
        menuIndex = "0";
        hasMenu = true;
      }
      
      // 其他页面对应的菜单索引
      if (name == "home") {
        menuIndex = "1";
        hasMenu = true;
      }
      if (name == "clinical") {
        menuIndex = "2";
        hasMenu = true;
      }
      if (name == "channels") {
        menuIndex = "3";
        hasMenu = true;
      }
      if (name == "physique") {
        menuIndex = "4";
        hasMenu = true;
      }
      if (name == "physiqueChildren") {
        menuIndex = "17";  // 儿童体质辨识激活状态
        hasMenu = true;
      }
      if (name == "covid19") {
        menuIndex = "5";
        hasMenu = true;
      }
      if (name == "videoConsultation") {
        menuIndex = "7";
        hasMenu = true;
      }
      if (name == "doctorVideo" || name == "agora") {
        menuIndex = "8";
        hasMenu = true;
      }
      if (name == "clinical2") {
        menuIndex = "9";
        hasMenu = true;
      }
      if (name == "slow") {
        menuIndex = "10";
        hasMenu = true;
      }
      if (name == "healthy") {
        // healthy 页面不对应任何Header菜单，排除在菜单检查之外
        hasMenu = false;
      }
      if (name == "acupuncture") {
        // acupuncture 页面不对应任何Header菜单，排除在菜单检查之外
        hasMenu = false;
      }
      if (name == "knowledge" || name == "knowledgeDetail") {
        // knowledge 页面不对应任何Header菜单，排除在菜单检查之外
        hasMenu = false;
      }
      if (name == "application") {
        // application 页面不对应任何Header菜单，排除在菜单检查之外
        hasMenu = false;
      }
      if (name == "liugan") {
        // liugan 页面不对应任何Header菜单，排除在菜单检查之外
        hasMenu = false;
      }
      if (name == "easy") {
        menuIndex = "16";
        hasMenu = true;
      }
      if (name == "fyyx") {
        menuIndex = "21";
        hasMenu = true;
      }
      if (name == "popularizeVideo") {
        // popularizeVideo 页面不对应任何Header菜单，排除在菜单检查之外
        hasMenu = false;
      }
      if (name == "physiqueSpecialWoMan") {
        menuIndex = "19";
        hasMenu = true;
      }
      if (name == "physiqueSpecialMan") {
        menuIndex = "18";
        hasMenu = true;
      }
      if (name == "clinicalKouqiang") {
        // clinicalKouqiang 页面不对应任何Header菜单，排除在菜单检查之外
        hasMenu = false;
      }
      // 如果当前页面有对应的菜单，检查菜单是否真的显示
      if (hasMenu && menuIndex !== null) {
        // 检查菜单是否真的在页面上显示
        if (this.isMenuVisible(menuIndex)) {
          this.activeIndex = menuIndex;
        } else {
          // 菜单被隐藏了，但避免在页面加载过程中跳转
          // 只有在用户主动导航时才跳转，避免权限更新过程中的冲突
          if (this.$route.name === name) {
            // 特殊处理：扶阳医学页面不重定向到首页
            if (name === 'fyyx') {
              this.activeIndex = menuIndex; // 仍然设置激活状态
              return;
            }
            this.$router.replace({ path: "/home" });
            return;
          }
        }
      }
      
      // 如果当前页面没有对应的菜单，则跳转到首页
      // 排除一些有自己导航的页面，这些页面不需要在Header菜单中显示
      const excludedPages = [
        "login", "forgetPassword", "fixPassword", "clinic", "demonstrate",
        "patient", "orderList", "diagnoseList", "physicalFitnessTest", 
        "prescription", "userCenter", "diagnoseHistory", "report", "application", "knowledge", "knowledgeDetail",
        "acupuncture", "healthy", "liugan", "clinicalKouqiang", "popularizeVideo"
      ];
      
      if (!hasMenu && !excludedPages.includes(name)) {
        console.log(`当前页面 ${name} 没有对应的菜单，跳转到首页`);
        this.$router.replace({ path: "/home" });
      }
    },
    
    /**
     * 点击外部区域时关闭用户下拉菜单
     */
    outsideClick() {
      this.showUserMenu = false;
    },
    
    /**
     * 点击头部左侧Logo时跳转到首页
     */
    handleGoHome() {
      this.$router.replace({
        path: "/home",
      });
    },
    
    /**
     * 关闭儿童体质辨识弹窗
     */
    handleCloseChildrenDialog() {
      this.$store.commit('setShowChildrenDialog', false);
    },
    
    /**
     * 确认儿童体质辨识类型选择
     * @param {Object} selectedType - 选择的类型信息，包含type和desc属性
     */
    handleConfirmChildren(selectedType) {
      // 关闭弹窗
      this.$store.commit('setShowChildrenDialog', false);
      console.log('选择的类型:', selectedType);
      
      // 根据选择的类型获取对应的路由配置
      const routeConfig = this.physiqueChildren[selectedType.type];
      if (routeConfig) {
        // 埋点统计：记录儿童体质辨识选择事件
        window.aplus_queue.push({
          action: "aplus.record",
          arguments: [
            "_sjy.physiqueChildren.clk",
            "CLK",
            {
              param1: 'physiqueChildren',
            },
          ],
        });
        
        // 跳转到体质辨识页面，并传递类型参数
        this.$router.push({
          path: routeConfig.path,
          query: { 
            ...routeConfig.query,
            ageDescription: selectedType.desc  // 添加年龄描述
          }
        });
        
        // 设置当前菜单名称为 physiqueChildren
        this.$store.commit("setCurrentMenuName", "physiqueChildren");
        
        // 显示成功提示
        this.$message.success(`正在进入${selectedType.desc}体质辨识`);
      } else {
        this.$message.error('暂无对应的页面配置');
      }
    },
    
  },
};
</script>

<style lang="less" scoped>
.header-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  min-width: 1200px;
  height: 62px;
  background-color: #19b2ad;

  .header-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1200px;
    height: 62px;
    margin: 0 auto;
  }

  .header-left {
    display: flex;
    font-size: 20px;
    font-weight: 600;
    color: #fff;
    align-items: center;
    cursor: pointer;

    .header-img {
      flex-shrink: 0;
      width: 99px;
      height: 40px;
      margin-right: 16px;
    }
  }

  .header-right {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
  }

  .header-menu {
    min-width: 528px;

    /deep/.el-menu {
      height: 62px;

      .el-menu-item {
        border-bottom: none;
        padding: 0 16px;
      }
    }

    .el-menu.el-menu--horizontal {
      border-bottom: none;
      display: flex;
      flex-wrap: nowrap;
      overflow-x: auto;
      &::-webkit-scrollbar {
        height: 6px;
        background-color: rgba(255, 255, 255, 0.4);
      }
    }

    /deep/.el-menu-item.is-active {
      font-weight: 600;
      color: #fff !important;
      background-color: #13bfba !important;
    }

    /deep/.el-menu--horizontal > .el-menu-item {
      height: 62px;
      line-height: 62px;
      font-size: 16px;
      font-weight: 400;
    }
  }

  .header-user {
    position: relative;
    display: flex;
    align-items: center;
    color: #fff;
    .user-menu {
      position: absolute;
      left: 0;
      bottom: -54px;
      width: 130px;
      padding: 4px 0;
      border-radius: 2px;
      box-shadow: 0px 0px 6px 0px rgba(38, 43, 48, 0.15);
      background-color: #fff;
      overflow: hidden;
      &.posi {
        bottom: -89px;
      }
      .user-menu-item {
        display: flex;
        align-items: center;
        // justify-content: center;
        width: 100%;
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        color: #383f47;
        padding-left: 12px;
        box-sizing: border-box;
        cursor: pointer;
        &:hover {
          background-color: #f2f5f7;
        }
        .icon {
          width: 20px;
          height: 20px;
          margin-right: 8px;
        }
      }
    }
    .avatar-img {
      width: 32px;
      height: 32px;
    }

    .name {
      max-width: 120px;
      font-size: 14px;
      color: #fff;
      margin: 0 4px 0 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
    }
    .arrow_down {
      width: 16px;
      height: 16px;
      background: url("@/assets/images/arrow_down.png") no-repeat center;
      background-size: 16px;
    }
  }
}
</style>
